const indexItems = [
  { title: '4K科幻大片合集', count: '326部', icon: 'ri-planet-line', color: 'accent' },
  { title: '蓝光经典重温', count: '512部', icon: 'ri-film-line', color: 'primary' },
  { title: '高分韩剧追更', count: '189部', icon: 'ri-heart-pulse-line', color: 'accent' },
  { title: '悬疑烧脑剧场', count: '278部', icon: 'ri-search-eye-line', color: 'secondary' },
  { title: '国产口碑佳作', count: '445部', icon: 'ri-flag-2-line', color: 'primary' },
  { title: '动漫新番速递', count: '367部', icon: 'ri-emotion-line', color: 'accent' },
  { title: '动作猛片专区', count: '293部', icon: 'ri-sword-line', color: 'secondary' },
  { title: '喜剧放松时刻', count: '241部', icon: 'ri-emotion-happy-line', color: 'primary' },
  { title: '纪录片精选', count: '158部', icon: 'ri-camera-lens-line', color: 'accent' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">影视专题</h2>
          <p className="mt-3 text-sm text-foreground-500">按类型探索您感兴趣的高清影视内容</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4">
          {indexItems.map((item, i) => {
            const bgClass = item.color === 'primary' ? 'bg-primary-100 hover:bg-primary-200' :
              item.color === 'accent' ? 'bg-accent-100 hover:bg-accent-200' :
              'bg-secondary-100 hover:bg-secondary-200';
            const iconBg = item.color === 'primary' ? 'bg-primary-500' :
              item.color === 'accent' ? 'bg-accent-500' :
              'bg-secondary-500';
            const textClass = item.color === 'primary' ? 'text-primary-700' :
              item.color === 'accent' ? 'text-accent-700' :
              'text-secondary-700';
            return (
              <div
                key={i}
                className={`${bgClass} rounded-xl p-5 cursor-pointer transition-colors group`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${iconBg} text-white mb-4`}>
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800">{item.title}</h3>
                <p className={`text-xs mt-1 ${textClass} font-medium`}>{item.count} 部影片</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}